import React, { useState, useEffect } from "react";
import { Route, Link, Switch, useParams} from "react-router-dom";
import '../../util/Quiz.css';
import authHeader from '../../services/auth-header';
import quizService from "../../services/quiz.service";
import { Card, ProgressBar } from 'react-bootstrap';

const QuizProgress = ({ selectedStudent: selectedStudentProp = "" }) => {

    const [quizzes, setQuizzes] = useState(null);
    const [selectedTopic, setSelectedTopic] = useState(null);
    const [loading, setLoading] = useState(true);
	const [topicQuizzes, setTopicQuizzes] = useState({});
	const [students, setStudents] = useState([]);
	const [selectedStudent, setSelectedStudent] = useState(selectedStudentProp);

	const topic_options = [
		// { value: '', label: '-' },
		{ value: 'query', label: 'Query' },
		{ value: 'data_cln', label: 'Data Cleaning' },
		{ value: 'data_pro', label: 'Data Preprocessing' },
		{ value: 'data_viz', label: 'Data Visualization' },
		{ value: 'feat_eng', label: 'Feature Engineering' },
		{ value: 'feat_sel', label: 'Feature Selection' },
		{ value: 'analysis', label: 'Analysis' }
	];

	const fetchQuizzes = async () => {
		const teacher = JSON.parse(localStorage.getItem("user")).username;
	try {
	const response = await quizService.quiz_progress_teacher(teacher, selectedStudent);
			const all_quizzes = response.quizzes.filter(element => element != null);
			setQuizzes(all_quizzes);
			const groupedQuizzes = all_quizzes.reduce((acc, quiz) => {
				if (!acc[quiz.course]) acc[quiz.course] = [];
				acc[quiz.course].push(quiz);
				return acc;
			}, {});
			setTopicQuizzes(groupedQuizzes);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching quizzes: ", error);
			setLoading(false);
		}
	};

	useEffect(() => {
		console.log("Im here......");
		const teacher = JSON.parse(localStorage.getItem("user")).username;
		const fetchStudents = async () => {
			try {
				const response = await quizService.get_teacher_students(teacher);
				const all_students = response.students.filter(element => element != null);
				setStudents(all_students);
				console.log("Teacher Students: ", all_students)
				setLoading(false);
				// If selectedStudentProp is present and valid, set it as selectedStudent
				if (selectedStudentProp && all_students.some(s => s.username === selectedStudentProp)) {
					setSelectedStudent(selectedStudentProp);
				}
			} catch (error) {
				console.error("Error fetching students: ", error);
				setLoading(false);
			}
		};
		fetchStudents();
	}, [selectedStudentProp]);

		useEffect(() => {
			if (selectedStudent) {
					fetchQuizzes();
			}
		}, [selectedStudent]); // Fetch quizzes whenever the selected student changes

    const calculateAverageProgress = (quizzes) => {
    if (!quizzes || quizzes.length === 0) return 0;
			const totalProgress = quizzes.reduce((acc, quiz) => acc + quiz.progress, 0);
			return totalProgress / quizzes.length;
    };

    // Function to get the variant color for the progress bar
    const getProgressVariant = (progress) => {
			if (progress < 60) return 'danger';
			if (progress < 80) return 'warning';
			return 'success';
    };
  
    return (
		<div className="container mx-auto pl-10">
			<h2 className="mb-4" style={{ fontSize: '2rem' }}>Quiz Progress</h2>
			
			<div className="mb-3">
				<label htmlFor="studentSelect">Select Student:</label>
				<select
					id="studentSelect"
					value={selectedStudent}
					onChange={(e) => setSelectedStudent(e.target.value)}
					className="form-select"
				>
					<option value="">-- Select a Student --</option>
					{students.map(student => (
						<option key={student.username} value={student.username}>
							{student.name && student.name.trim() !== '' ? student.name : student.username}
							{student.email && student.email.trim() !== '' ? ` (${student.email})` : ''}
						</option>
					))}
				</select>
			</div>

			{selectedStudent && topic_options.map(({ value, label }) => {
				const quizzes = topicQuizzes[value] || [];
				const averageProgress = calculateAverageProgress(quizzes);
				return (
					<div style={{ backgroundColor: '#efefef'}} className="mb-4 pb-4 pt-4">
						<Card key={value} 
							onClick={() => setSelectedTopic(selectedTopic === value ? null : value)}
							className="ml-4 mr-4 mt-0 mb-0 topic-card" >
							<Card.Body>
								<Card.Title>
									<h5
										style={{ cursor: 'pointer', color: selectedTopic === value ? 'blue' : 'black' }}
									>
										Topic: {label} 
									</h5>
								</Card.Title>
								<small style={{ color: 'black' }}>(Number of Quizzes: {quizzes.length})</small>
								<br />
								<small style={{ color: 'black' }}>Progress:</small>
								<ProgressBar
									now={averageProgress}
									label={`${Math.round(averageProgress)}%`}
									variant={getProgressVariant(averageProgress)}
									style={{ height: '1rem' }}
								/>
							</Card.Body>
						</Card>
						{/* Conditionally render quizzes for the selected topic */}
						{selectedTopic === value && (
							<div style={{ marginTop: '5px', padding: '0px'}}>
								{quizzes.map((quiz, index) => (
									<Card key={index} className="ml-5 mr-5 mt-3 mb-3 p-0 shadow-sm" 
										// style={{ backgroundColor: '#f9f9f9' }}
										>
										<Card.Body>
											<Card.Title><h5 style={{ color: 'black' }}>{quiz.title}</h5></Card.Title>
											<small style={{ color: 'black' }}>Number of Questions: {quiz.total_question}</small>
											<br />
											<small style={{ color: 'black' }}>Correctly Answered: {quiz.total_correct}</small>
											<br />
											<small style={{ color: 'black' }}>Progress:</small>
											<ProgressBar
												now={quiz.progress}
												label={`${quiz.progress}%`}
												variant={getProgressVariant(quiz.progress)}
												style={{ height: '0.8rem' }}
											/>
										</Card.Body>
									</Card>
								))}
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default QuizProgress;